export default __webpack_public_path__ + "static/1861-f7e525b0238cee3d76d8f87e35d9514b.gif";